import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UtilityService } from '@services/utility.service';
import { MarkdownModule } from 'ngx-markdown';

import { BannerPlacement } from 'src/app/core/enums/banner.enum';
import { IQuotesTariff } from 'src/app/core/models/quotesTariff.interface';
import { IBanner, IBannerPopup } from 'src/app/core/models/tenancy.interface';

@Component({
  selector: 'app-exclusive-tag',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  templateUrl: './exclusive-tag.component.html',
  styleUrl: './exclusive-tag.component.scss'
})
export class ExclusiveTagComponent implements OnInit, OnChanges {
  utilityService = inject(UtilityService);

  @Input('type') type: string = '';
  @Input('placement') placement: string = '';
  @Input('exclusive') exclusive: IBanner[] = [];
  @Input('quote') quote: IQuotesTariff;

  exclusiveTabPlacements: any = BannerPlacement;
  selectedBanner: IBanner;
  selectedQuote: IQuotesTariff;

  bannerTemplate = '';

  showTrackerInfo: boolean = false;

  openMessage = (fileName: string) => this.utilityService.openMessageDialog(fileName);

  ngOnInit(): void {
    // Check if the exclusive tag is available for the selected placement
    const banner = (this.exclusive && this.exclusive.length > 0) ? this.exclusive.filter((tab: IBanner) => tab.placetoDisplay === this.placement && tab.status === 'active') : null;

    // Sort by priority
    const sortedBanner: IBanner[] = banner?.sort((a: IBanner, b: IBanner) => {
      return a.priority - b.priority;
    });


    // Selected quote
    sortedBanner.map((banner: IBanner, index: number) => {
      if (!this.selectedQuote) {
        // Selected Banner
        this.selectedBanner = sortedBanner[index];
        this.selectedQuote = this.utilityService.findQuoteByFilterKey([this.quote], banner.dynamicContentUniqueKey)?.[0];
      }
    });

    // Selected Banner to load script
    if (this.selectedBanner) {
      // Check if the selected tab is available for the selected type
      try {
        // scriptSource is the script source for the exclusive tag
        this.selectedBanner.scriptSource = JSON.parse(this.selectedBanner.scriptSource);
      } catch (error) {
        // console.error('Error parsing scriptSource JSON:', error);
      }
    }

    if ((this.type === 'tag' || this.type === 'appInfo' || this.type === 'ctmRewards' || this.type === 'infoBar') && this.selectedBanner) {
      this.bannerTemplate = this.processPopupLink(this.selectedBanner.content, this.selectedBanner.popup);
    }
  }

  private processPopupLink(content: string, popup?: IBannerPopup): string {
    if (!popup || !popup.text || !popup.link) {
      return content;
    }

    // Replace the popup text with a clickable link
    const linkHtml = '<a href="#" class="popup-link">' + popup.text + '</a>';
    return content.replace(popup.text, linkHtml);
  }

  handlePopupClick(event: Event): void {
    const target = event.target as HTMLElement;
    // Check if the clicked element or its parent is the popup link
    const linkElement = target.closest('.popup-link') as HTMLElement;
    if (linkElement && this.selectedBanner?.popup?.link) {
      event.preventDefault();
      this.openMessage(this.selectedBanner.popup.link);
    }
  }

  /**
   * @description Toggle tracker info tooltip visibility for mobile/tablet click interaction
   */
  toggleTrackerInfo(): void {
    if (window.innerWidth <= 767) {
      this.showTrackerInfo = !this.showTrackerInfo;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['exclusive'] && changes['exclusive'].currentValue) {
      this.exclusive = changes['exclusive'].currentValue;
    }
  }
}
